import { AdaBindMethodPipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { SerializedPropertyMapPipe } from '@adaptiva/metadata/common';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { ExpressionLanguageEditorModule } from '@adaptiva/widgets/expression-editor';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TableColumnDirective, TableComponentModule } from '@adaptiva/widgets/table';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { SensorActionSequenceComponent } from './sensor-action-sequence.component';

const PIPES: Type<any>[] = [
	AdaBindMethodPipe,
	SerializedPropertyMapPipe
];

const WIDGETS: Type<any>[] = [
	AlertComponentModule,
	ButtonComponentModule,
	ComboComponentModule,
	ContainerComponentModule,
	ExpressionLanguageEditorModule,
	InputComponentModule,
	LabelComponentModule,
	OverlayComponentModule,
	MenuComponentModule,
	TableComponentModule,
	TextComponentModule,
	ToggleSwitchComponent,
];

@NgModule({
	imports: [
		CommonModule,
		TableColumnDirective,
		TemplateMarkerDirectiveModule,
		PIPES,
		WIDGETS
	],
	declarations: [SensorActionSequenceComponent],
	exports: [SensorActionSequenceComponent]
})
export class SensorActionSequenceComponentModule {

}
